package com.flowyride.core.fileexport

import androidx.compose.runtime.Composable

/** A text file to hand over to the user (share sheet on mobile, download on web). */
data class ExportableFile(
    val fileName: String,
    val mimeType: String,
    val content: String,
)

fun interface FileExporter {
    /** @throws Exception when the platform could not export the file. */
    suspend fun export(file: ExportableFile)
}

/** Platform [FileExporter] bound to the current UI host (Activity, UIViewController, browser window). */
@Composable
expect fun rememberFileExporter(): FileExporter
